import { render } from "./outgoing-mail.vue?vue&type=template&id=62c0f138"
import script from "./outgoing-mail.vue?vue&type=script&lang=js"
export * from "./outgoing-mail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__